module.exports = __webpack_public_path__ + "static/desktop/img/typeset-tablet-diarybook.ded16bdd.png";